module.exports = __webpack_public_path__ + "h5/img/cygn15.2dfc981a.png";